import React from "react";
import SingleLeadContent from "../components/leads/single-lead-content";

const SingleLead = () => {
  return <SingleLeadContent />;
};

export default SingleLead;
